import React from "react";
import ModalInfo from "../../ModalInfo";

class Page4 extends React.Component {
  state = {
    visible: true,
    questionAnswer: null,
    modalShow: true,
    modalTitle: "INSTRUCTIONS",
    modalContent: (
      <div>
        <p>
          If you’re after some tools to help with decision making, give the
          DECIDES model a go. This is quite a structured framework which may
          help focus your thinking. See example by clicking on the different
          fields.
        </p>
      </div>
    ),
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 4) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }

  saveAnswerChange = (event) => {
    this.setState({ questionAnswer: event.target.value });
    this.props.updatePdf(event.target.value);
  };

  render() {
    let modalClose = () => this.setState({ modalShow: false });

    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0  d-md-block">DECIDES model</h3>
                </li>
                <li className="nav-item"></li>
              </ul>
              <ul className="nav navbar-nav ml-auto">
                <div>
                  <i
                    className="fas fa-info-square fa-3x"
                    onClick={() =>
                      this.setState({
                        modalShow: true,
                        modalTitle: "INSTRUCTIONS",
                        modalContent: (
                          <div>
                            <p>
                              If you’re after some tools to help with decision
                              making, give the DECIDES model a go. This is quite
                              a structured framework which may help focus your
                              thinking. See example by clicking on the different
                              fields.
                            </p>
                          </div>
                        ),
                      })
                    }
                  ></i>
                </div>
              </ul>
            </nav>
            <br />
            <br />
            <div className="container-fluid row d-flex justify-content-center">
              <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 ">
                <div className="card mb-4 box-shadow h-100 " id="pageContent_2">
                  <ul className="list-group list-group-flush text-dark ">
                    <li
                      className="list-group-item form-card-selectable form-card-1 "
                      onClick={() =>
                        this.setState({
                          modalShow: true,
                          modalTitle: "Define the problem ",
                          modalContent: (
                            <div>
                              <p>
                                <i>
                                  <strong>Example:</strong>
                                </i>
                                <br /> <br />
                                Not sure whether to apply for a PhD or work as a
                                Research Assistant for a year.
                              </p>
                            </div>
                          ),
                        })
                      }
                    >
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <h1>
                            <span className="badge badge-secondary">D</span>
                          </h1>
                        </div>
                        <div className="p-2" id="moduleContentText">
                          - <strong>define</strong> the problem
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item form-card-selectable form-card-2"
                      onClick={() =>
                        this.setState({
                          modalShow: true,
                          modalTitle: "Establish a plan of action ",
                          modalContent: (
                            <div>
                              <p>
                                <i>
                                  <strong>Example:</strong>
                                </i>
                                <br /> <br />
                                I will talk to my course tutor about pros and
                                cons.
                                <br />
                                <br />
                                I’ll speak to current PhD students in my
                                department to find out how they made decisions.
                                <br />
                                <br />I haven’t worked in industry and should
                                really find out what its really like.
                              </p>
                            </div>
                          ),
                        })
                      }
                    >
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <h1>
                            <span className="badge badge-secondary">E</span>
                          </h1>
                        </div>
                        <div className="p-2" id="moduleContentText">
                          - <strong>establish</strong> a plan of action
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item form-card-selectable form-card-1"
                      onClick={() =>
                        this.setState({
                          modalShow: true,
                          modalTitle:
                            "Clarify underlying values and interests ",
                          modalContent: (
                            <div>
                              <p>
                                <i>
                                  <strong>Example:</strong>
                                </i>{" "}
                                <br />
                                <br />I am quite sociable and need variety to
                                keep me engaged. I need to find out if doing a
                                PhD fits with my values and strengths.
                              </p>
                            </div>
                          ),
                        })
                      }
                    >
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <h1>
                            <span className="badge badge-secondary">C</span>
                          </h1>
                        </div>
                        <div className="p-2" id="moduleContentText">
                          - <strong>clarify</strong> underlying values and
                          interests
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item form-card-selectable form-card-2"
                      onClick={() =>
                        this.setState({
                          modalShow: true,
                          modalTitle:
                            "Identify the key alternatives that you are deciding between ",
                          modalContent: (
                            <div>
                              <p>
                                <i>
                                  <strong>Example:</strong>
                                </i>{" "}
                                <br />
                                <br />I have only ever worked in a University
                                lab. I don’t know what other options are out
                                there especially in industry using chemistry.
                              </p>
                            </div>
                          ),
                        })
                      }
                    >
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <h1>
                            <span className="badge badge-secondary">I</span>
                          </h1>
                        </div>
                        <div className="p-2" id="moduleContentText">
                          - <strong>identify</strong> the key alternatives that
                          you are deciding between
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item form-card-selectable form-card-1"
                      onClick={() =>
                        this.setState({
                          modalShow: true,
                          modalTitle:
                            "Discover the probable outcome of each alternative ",
                          modalContent: (
                            <div>
                              <p>
                                <i>
                                  <strong>Example:</strong>
                                </i>
                                <br /> <br />
                                If I just jump in and do a PhD, I may not enjoy
                                it and 4-years may feel like a life sentence.
                                <br />
                                <br />
                                I have nothing to lose by taking a year out. I
                                could work in a research role in industry and
                                experience what it’s really like.
                                <br />
                                <br />I may even become clearer about my
                                research interests which will focus my PhD
                                subject .
                              </p>
                            </div>
                          ),
                        })
                      }
                    >
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <h1>
                            <span className="badge badge-secondary">D</span>
                          </h1>
                        </div>
                        <div className="p-2" id="moduleContentText">
                          - <strong>discover</strong> the probable outcome of
                          each alternative
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item form-card-selectable form-card-2"
                      onClick={() =>
                        this.setState({
                          modalShow: true,
                          modalTitle: "Eliminate alternatives systematically ",
                          modalContent: (
                            <div>
                              <p>
                                <i>
                                  <strong>Example:</strong>
                                </i>
                                <br /> <br />
                                The option of doing a PhD will be there if I
                                take a year out. I don’t need to rush into
                                things.
                              </p>
                            </div>
                          ),
                        })
                      }
                    >
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <h1>
                            <span className="badge badge-secondary">E</span>
                          </h1>
                        </div>
                        <div className="p-2" id="moduleContentText">
                          - <strong>eliminate</strong> alternatives
                          systematically
                        </div>
                      </div>
                    </li>
                    <li
                      className="list-group-item form-card-selectable form-card-1"
                      onClick={() =>
                        this.setState({
                          modalShow: true,
                          modalTitle: "Start action ",
                          modalContent: (
                            <div>
                              <p>
                                <i>
                                  <strong>Example:</strong>
                                </i>
                                <br />
                                <br />
                                I need to meet with my Careers Adviser to find
                                out how I can get a research role in industry.
                                <br />
                                <br />I should register for the careers fair and
                                go and talk to as many pharmas as possible.
                              </p>
                            </div>
                          ),
                        })
                      }
                    >
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <h1>
                            <span className="badge badge-secondary">S</span>
                          </h1>
                        </div>
                        <div className="p-2" id="moduleContentText">
                          - <strong>start</strong> action
                        </div>
                      </div>
                    </li>
                  </ul>
                  <p
                    className="text-dark"
                    style={{ marginTop: "5px", fontSize: "12px" }}
                  >
                    <i>
                      Adapted from: Kristina Guo PhD, MHP The Health Care
                      Manager April 2008
                    </i>
                  </p>
                  <ul className="list-group list-group-flush text-dark ">
                    <li className="list-group-item form-card-1">
                      <div className="d-flex align-items-center">
                        <div className="p-2" id="moduleContentText">
                          <i>
                            Why not give this a go? It may also be worth
                            checking the outcome against what your heart is
                            telling you:
                          </i>
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item form-card-2">
                      <div id="moduleContentText">
                        <div className="d-flex flex-column bd-highlight mb-3">
                          <div className="form-group">
                            <textarea
                              className="form-control "
                              id="exampleFormControlTextarea1"
                              placeholder="Enter your answer here..."
                              rows="20"
                              value={this.state.questionAnswer}
                              onChange={this.saveAnswerChange}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <ModalInfo
              show={this.state.modalShow}
              onHide={modalClose}
              title={this.state.modalTitle}
              content={this.state.modalContent}
            />
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page4;
